// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner_root__EDTC7 icon_root__nC2lM items-center inline-flex justify-center","icon":"spinner_icon__UEcJA icon_icon__ckKxp animation-spin"};